import React from "react";
import { useTranslation } from "react-i18next";
import { Reveal, Overline } from "./Reveal";
import { SEGMENTS } from "../data/plans";
import { IMAGES } from "../data/config";

export function WhoIsItFor() {
  const { t } = useTranslation();
  return (
    <section className="py-24 md:py-32 border-t border-white/5" data-testid="who-is-it-for">
      <div className="container-x">
        <Reveal>
          <Overline color="gold">{t("who.overline")}</Overline>
          <h2 className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-3xl">{t("who.title")}</h2>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SEGMENTS.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.06}>
              <article className="group relative h-72 rounded-xl overflow-hidden border border-white/10 surface-hover" data-testid={`segment-card-${s.id}`}>
                <img src={IMAGES[s.image]} alt={t(`data.segments.${s.id}.title`)} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/70 to-navy-900/10" />
                <div className="absolute inset-0 p-6 flex flex-col justify-end">
                  <h3 className="font-display font-semibold text-xl text-white">{t(`data.segments.${s.id}.title`)}</h3>
                  <p className="mt-2 text-sm text-white/65 leading-relaxed">{t(`data.segments.${s.id}.desc`)}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhoIsItFor;
